import { createContext, useContext, useEffect, useState } from "react"
import { IRecipe } from "../shared/Recipes"
import { useLogin } from "../gui/Login/LoginProvider"
import RecipeCache from "../data/RecipeCache"
import { useSnackbar } from "../gui/Snackbar/SnackbarProvider"
import { TSelect } from "../gui/Select/Select"
import Usernames from "../libs/login/Usernames"
import Foods from "../data/Foods"
import { useAuth } from "../gui/Login/AuthProvider"

export type TRecipesContext = {
    recipes:IRecipe[]|undefined
    options:TSelect<string|number>[]|undefined
}

const RecipesContext = createContext<TRecipesContext>({} as any)
export const useRecipes = () => useContext(RecipesContext)

export default function RecipesProvider(props:{children:JSX.Element}) {
    const [recipes,setRecipes] = useState<IRecipe[]|undefined>(undefined)
    const [options,setOptions] = useState<TSelect<string|number>[]|undefined>(undefined)

    const {login} = useLogin()
    const {isLoggedIn} = useAuth()
    const {addSnackbar} = useSnackbar()

    const refresh = async () => {
        try {
            const recipes = await RecipeCache.i.getRecipes().then(all => all.items)
            setRecipes(recipes)

            const userIds = Array.from(new Set(recipes.map(r => r.user)))
            const userNamesList = await Usernames.i.getBatch(userIds)
            const userNames = Object.fromEntries(userIds.map( (id,i) => [id, userNamesList[i]||"Unknown"]))
            setOptions([
                ...recipes.map(recipe => ({id:recipe._id,text:`${recipe.name} by ${userNames[recipe.user]}`})),
                ...Foods.i.options
            ].sort((l,r) => l.text.localeCompare(r.text)))
        }catch(e){
            addSnackbar(e)
        }
    }
    useEffect(() => {
        console.log("recipes provider", isLoggedIn, login)
        if (isLoggedIn) {
            refresh()
            RecipeCache.i.on("update", refresh)
        }
        else {
            setRecipes(undefined)
            RecipeCache.i.removeListener("update", refresh)
        }
        return () => { isLoggedIn && RecipeCache.i.removeListener("update", refresh) }
    }, [isLoggedIn])
    return <RecipesContext.Provider value={{recipes,options}}>{props.children}</RecipesContext.Provider>
}
